import { SchemaDefinition } from '@/components/EvaluatorCrudPane/utils/serializeFeedbackUIToLC';

export function hasExactlyOneBooleanKeyExcludingReasoning(
  schema: SchemaDefinition
): boolean {
  const nonCorrectnessKeys = Object.keys(schema.properties).filter(
    (key) => key !== 'comment'
  );

  if (nonCorrectnessKeys.length !== 1) {
    return false;
  }

  const key = nonCorrectnessKeys[0];
  return schema.properties[key].type === 'boolean';
}
